import { SearchJobsRequest, SearchJobsResponse, MarkInvoicedCommand, MarkInvoicedResponse, GetJobsListQuery, GetJobsListResponse, MergeJobsCommand, Job, MergeJobsResponse, ExportJobsCommand } from "../model/jobModel";
import { apiCall, apiCallNoResponse } from "./sharedAsync";


var jobListAbortController: AbortController | null = null;

export const apiSearchJobs = async (payload: SearchJobsRequest, token: string, rejectWithValue: (value: string) => void) => {
    return await apiCall<SearchJobsResponse, SearchJobsRequest>(token, "/job/search?SearchTerm=" + payload.searchTerm, "GET", rejectWithValue, "Unable to load jobs");
}

export const apiMarkInvoiced = async (payload: MarkInvoicedCommand, token: string, rejectWithValue: (value: string) => void) => {
    return await apiCall<MarkInvoicedResponse, MarkInvoicedCommand>(token, "/job/invoiced", "POST", rejectWithValue, "Unable to update job invoiced status.", payload);
}

export const apiGetJobsList = async (payload: GetJobsListQuery, token: string, rejectWithValue: (value: string) => void) => {
    if(jobListAbortController !== null ){
        jobListAbortController.abort();
    }
    jobListAbortController = new AbortController();
    return await apiCall<GetJobsListResponse, GetJobsListQuery>(token, "/job/list", "POST", rejectWithValue, "Unable to load jobs", payload, jobListAbortController.signal);
}

export const apiMergeJobs = async (payload: MergeJobsCommand, token: string, rejectWithValue: (value: string)=>void) => {
    return await apiCall<MergeJobsResponse, MergeJobsCommand>(token, "/job/merge", "POST", rejectWithValue, "Failed to merge jobs", payload); 
}

export const apiExportJobs = async (payload: ExportJobsCommand, token: string, rejectWithValue: (value: string)=>void) => {
    return await apiCallNoResponse<ExportJobsCommand>(token, "/job/export", "POST", rejectWithValue, "Failed to export jobs", payload); 
}

export const apiDeleteJob = async (id: number, token: string, rejectWithValue: (value: string)=>void) => {
    return await apiCallNoResponse<void>(token, `/job/${id}`, "DELETE", rejectWithValue, "Failed to delete job");
}

export const apiRenameJob = async (payload: { jobId: number; newName: string }, token: string, rejectWithValue: (value: string)=>void) => {
    return await apiCallNoResponse<typeof payload>(token, "/job/rename", "POST", rejectWithValue, "Failed to rename job", payload);
}
